import { render, staticRenderFns } from "./InfoTitle.vue?vue&type=template&id=fcb026f0&"
import script from "./InfoTitle.vue?vue&type=script&lang=js&"
export * from "./InfoTitle.vue?vue&type=script&lang=js&"
import style0 from "./InfoTitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcb026f0')) {
      api.createRecord('fcb026f0', component.options)
    } else {
      api.reload('fcb026f0', component.options)
    }
    module.hot.accept("./InfoTitle.vue?vue&type=template&id=fcb026f0&", function () {
      api.rerender('fcb026f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SankeyV2/TouchpointInfo/InfoTitle.vue"
export default component.exports